// Marca del panel clínico — Dr. Pablo Salgado (único archivo distinto entre los sitios)
export const BRAND = {
  key: "gastrosalgado",
  specialty: "gastro",
  name: "Dr. Pablo Salgado",
  doctor: "Dr. Pablo Salgado",
  tagline: "Gastroenterología y Endoscopía",
  logo: "/img/logo.webp",
  logoClass: "h-14",
  email: "citas@drpablosalgado.com",
  phone: "099 311 8688",
  address: "Hospital de Especialidades · Torre Sur, Piso 4, Consultorio 402",
  defaultPlace: "Torre Sur, Consultorio 402",
  tokenKey: "gs_token",
  themeKey: "gs_theme",
  services: ["Consulta de gastroenterología", "Control / seguimiento", "Endoscopía digestiva alta", "Colonoscopía", "CPRE", "Polipectomía",
    "Dilatación / stent", "Balón gástrico", "Control de peso", "Hígado graso / hepatitis"],
  slotHours: [8, 18],
  openSundays: false,
  reminderRule: "(7 días antes a pacientes en control periódico; 5 días antes al resto si la cita es a 30 días o más de la atención).",
  cssVars: { "--brand": "#1D4ED8", "--brand2": "#0EA5E9", "--accent": "#0EA5E9", "--font-head": "'Outfit', 'Plus Jakarta Sans', sans-serif" },
};
